import React, { useEffect, useState } from "react";
import { useContext } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "bootstrap/dist/css/bootstrap.min.css";
import Step1 from "./Step01";
import Step2 from "./Step02";
import Step3 from "./Step03";
import MultiStepProgressBar from "./MultiStepProgressBar";
import "../../assets/css/Booking.css";
import moment from "moment";
import Step4 from "./Step04";
import "react-notifications/lib/notifications.css";
import { BookingContext } from "./BookingContext";
import { LoginContext } from "../../LoginContext";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  addbooking,
  SignUp,
  getuserdetails,
  getsubservicebyservice,
  getaddon,
  updateBookingData
} from "../../Api/frontbooingApi";
import { getdata } from "../../../Api/bookingApi";
import { FaExclamationTriangle } from "react-icons/fa";

const MasterForm = ({ orderId }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [address, setAddress] = useState("");
  const [validationError, setValidationError] = useState("");

  const [
    usertype,
    setUsertype,
    chooseservice,
    setChooseservice,
    choosesubservice,
    setChoosesubservice,
    chooseaddon,
    setChooseaddon,
    choosetechnician,
    setChoosetechnician,
    choosedate,
    setChoosedate,
    choosetime,
    setChoosetime,
    userDetails,
    setUserDetails,
    paymentDetails,
    setPaymentDetails,
    Totalpayment,
    setTotalpayment,
    totalDuration,
    setTotalDuration,
    appointmentNotes,
    setAppointmentNotes,
    servicename,
    setServicename,
    endchoosetime,
    setEndchoosetime,
    confirmpassword,
    setConfirmpassword,
    signUprequest,
    setSignUprequest,
    technicianList,
    setTechnicianList,
    expectedprice,
    setExpectedprice,
    expectedduration,
    setExpectedduration,
    availableTimestatus,
    setAvailableTimestatus,
    resetChoosetechnician,
    zipcode,
    setZipcode,
    bookingdata,
    setBookingData,
    Newservicepercentage,
    setNewServicepercentage,
    oldtotalprice,
    setOldtotalPrice,
    promodata,
    setPromodata,
    amountwithdiscount,
    setAmountwithdiscount,
    specialClientRequests,
    setSpecialClientRequests,
    bookingTime,
    setBookingTime,
    clientNotes,
    setClientNotes,
    selectedShift,
    setSelectedShift,
    hasCats,
    setHasCats,
    hasDogs,
    setHasDogs,
  ] = useContext(BookingContext);

  const { LoggedInData, login, logout } = useContext(LoginContext);
  const [billedhours, setBilledhours] = useState("0");

  const [userbilledhours, setUserbilledhours] = useState(0);
  const [userbilledamount, setUserbilledamount] = useState(0);
  const [isBookingBlocked, setIsBookingBlocked] = useState(false);
  const [invoiceCheckDone, setInvoiceCheckDone] = useState(false);
  const [invoiceAttemptedMessage, setInvoiceAttemptedMessage] = useState("");
  const [userid, setUserid] = useState("");

  const [defaultsubservice, setdefaultsubservice] = useState([]);
  const [defaultaddons, setdefaultaddons] = useState([]);

  useEffect(() => {
    if (LoggedInData != null) {
      // setUserbilledhours(LoggedInData.billed_hours);
      // setUserbilledamount(LoggedInData.billed_amount);
      setUserid(LoggedInData.id);
    }
  }, [LoggedInData]);

  useEffect(() => {
    setIsBookingBlocked(false);
    setInvoiceCheckDone(false);
    setInvoiceAttemptedMessage("");

    if (LoggedInData === undefined) {
      return;
    }

    if (!LoggedInData || !LoggedInData.id) {
      setIsBookingBlocked(false);
      setInvoiceCheckDone(true);
      return;
    }

    const formData = new FormData();
    formData.append("user_id", LoggedInData.id);

    getdata(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status === "success") {
            setIsBookingBlocked(false);
          } else {
            const rawMessage = res?.data?.message || "Something went wrong";
            const cleanedMessage = rawMessage
              .replace("<p>", "")
              .replace("</p>", "")
              .trim();

            // NotificationManager.error(cleanedMessage, "Error", 3000);

            if (cleanedMessage
              // cleanedMessage.toLowerCase().includes("pending invoice") ||
              // cleanedMessage.includes("Customer Has PENDING Invoice") ||
              // cleanedMessage.includes("PENDING Invoice")
            ) {
              setIsBookingBlocked(true);
              setInvoiceAttemptedMessage(cleanedMessage);
            } else {
              setIsBookingBlocked(false);
            }
          }
        } else {
          NotificationManager.error("Something went wrong", "Error", 3000);
          setIsBookingBlocked(false);
        }
      })
      .catch(() => {
        setIsBookingBlocked(false);
      })
      .finally(() => {
        setInvoiceCheckDone(true);
      });
  }, [LoggedInData]);

  useEffect(() => {
    if (chooseservice === "1") {
      const formData = new FormData();
      // formData.append("user_id", LoggedInData.id);
      if (LoggedInData && LoggedInData.id) {
        formData.append("user_id", LoggedInData.id);
      } else {
        console.error("LoggedInData is null or does not have an id property");
      }
      getuserdetails(formData).then((res) => {
        if (res.code === 200) {
          if (res.data.status === 1) {
            const apiResponse = res.data;
            setUserbilledhours(apiResponse.data.billed_hours);
            setUserbilledamount(apiResponse.data.billed_amount);
          }
        } else {
          alert("Something went wrong");
        }
      });
    }
  }, [chooseservice]);

  useEffect(() => {
    if (chooseservice === 0) {
      setdefaultsubservice([]);
      setdefaultaddons([]);
    }

    getsubservice();
    getaddonsservice();
  }, [chooseservice]);

  const getsubservice = () => {
    // setLoading(true);
    const formData = new FormData();
    formData.append("service_id", chooseservice);
    formData.append("user_id", userid);
    getsubservicebyservice(formData).then((res) => {
      if (res.code === 200) {
        // setLoading(false);
        const apiResponse = res.data;
        // setSubService(apiResponse.data);
        setdefaultsubservice(apiResponse.data);
      } else {
        alert("Something went wrong");
      }
    });
  };

  console.log("userDetailsuserDetailsuserDetails", userDetails);

  const getaddonsservice = () => {
    const formData = new FormData();
    formData.append("service_id", chooseservice);
    formData.append("user_id", userid);
    getaddon(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status === "1") {
          const apiResponse = res.data;
          setdefaultaddons(apiResponse.data);
        } else {
          setdefaultaddons([]);
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const [signuploader, setSignUpLoader] = useState(false);

  const UserSignUp = (event) => {
    setSignUpLoader(true);

    if (
      userDetails.user_email == "" ||
      userDetails.password == "" ||
      confirmpassword == "" ||
      userDetails.first_name == "" ||
      userDetails.last_name == "" ||
      userDetails.zip == "" ||
      userDetails.address == "" ||
      userDetails.state == "" ||
      userDetails.city == ""
    ) {
      //      NotificationManager.error('Password and confirm password should be same', 'Close after 3000ms', 3000);
      setSignUprequest(signUprequest + 1);
      setSignUpLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append("email", userDetails.user_email);
    formData.append("password", userDetails.password);
    formData.append("confirmpassword", confirmpassword);
    formData.append("first_name", userDetails.first_name);
    formData.append("last_name", userDetails.last_name);
    formData.append("phone", userDetails.phone);
    formData.append("zipcode", userDetails.zip);
    formData.append("address", userDetails.address);
    formData.append("state", userDetails.state);
    formData.append("city", userDetails.city);
    formData.append("user_type", "0");
    SignUp(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status == "1") {
          setSignUpLoader(false);
          const apiResponse = res.data;
          login(apiResponse.data);
          setChoosetechnician(choosetechnician);
        } else {
          //get error message
          if (res.data.message) {
            var error = res.data.message.match(/<p>(.*?)<\/p>/g);
            // var errorString = "";
            error.forEach((element) => {
              // errorString += element.replace("<p>", "").replace("</p>", "") + "\n";
              // NotificationManager.error(element.replace("<p>", "").replace("</p>", ""), 'Close after 3000ms', 3000);
              let errorText = element.replace("<p>", "").replace("</p>", "");

              if (
                errorText.includes(
                  "The Email field must contain a unique value"
                )
              ) {
                errorText =
                  "Looks like you already have an account. You can log in or reset your password.";
                setUserDetails({
                  ...userDetails,
                  emailexist: true,
                  emailvalidatemsg:
                    "Looks like you already have an account. You can log in or reset your password.",
                });
              }

              NotificationManager.error(errorText, "Close after 3000ms", 3000);
            });
            // NotificationManager.error(errorString, 'Close after 3000ms', 3000);

            // setUserDetails({ ...userDetails, emailexist: true, emailvalidatemsg: errorString });
            setSignUpLoader(false);
          }
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "username":
        setUsername(value);
        break;
      case "password":
        setPassword(value);
        break;
      case "address":
        setAddress(value);
        break;
      default:
        break;
    }
  };

  const nextStep = () => {
    setCurrentStep((prevStep) => (prevStep >= 3 ? 4 : prevStep + 1));
  };

  const prevStep = () => {
    setCurrentStep((prevStep) => (prevStep <= 1 ? 1 : prevStep - 1));
  };

  const previousButton = () => {
    if (currentStep !== 1) {
      return (
        <Button
          color="secondary float-left"
          className="wizard-btn"
          onClick={prevStep}
        >
          Previous
        </Button>
      );
    }
    return null;
  };

  const nextButton = () => {
    if (currentStep < 4) {
      if (currentStep == 1) {
        if (chooseservice.length == 0 || technicianList.length == 0) {
          return (
            <Button
              color="primary float-right"
              className="wizard-btn"
              disabled
              style={{ display: "none" }}
            >
              {" "}
              Next{" "}
            </Button>
          );
        } else {
          return (
            <Button
              color="primary float-right"
              className="wizard-btn"
              onClick={nextStep}
            >
              Next
            </Button>
          );
        }
      } else if (currentStep == 2) {
        // Next button always enabled, validate on click
        return (
          <Button
            color="primary float-right"
            className="wizard-btn"
            onClick={() => {
              const hasTimeSlot =
                choosetime &&
                choosetime !== "" &&
                (!Array.isArray(choosetime) || choosetime.length > 0);
              const hasSpecialRequest =
                specialClientRequests && specialClientRequests.trim() !== "";
              
              // Check if slots are actually available
              const slotsAvailable = window.slotsAvailable !== false;

              
              if (!bookingTime || bookingTime.trim() === "") {
                setValidationError("Please enter booking time to proceed");
                return;
              }
              if (!clientNotes || clientNotes.trim() === "") {
                setValidationError("Please enter your instructions to proceed");
                return;
              }
              setValidationError("");
              nextStep();
            }}
          >
            Next
          </Button>
        );
      } else if (currentStep == 3) {
        if (LoggedInData != null) {
          return (
            <Button
              color="primary float-right"
              className="wizard-btn"
              onClick={nextStep}
            >
              Next
            </Button>
          );
        } else {
          return (
            <>
              {" "}
              {signuploader ? (
                <Button
                  color="primary float-right"
                  className="wizard-btn"
                  disabled
                >
                  {" "}
                  Creating...{" "}
                </Button>
              ) : (
                <Button
                  color="primary float-right"
                  className="wizard-btn"
                  onClick={UserSignUp}
                >
                  {" "}
                  Next{" "}
                </Button>
              )}
            </>
          );
        }
      } else {
        return (
          <Button
            color="primary float-right"
            className="wizard-btn"
            onClick={nextStep}
          >
            Next
          </Button>
        );
      }
    }
    return null;
  };

  // console.log("paymentDetails", paymentDetails);

  const submitButton = () => {
    if (currentStep > 3) {
      if (
        paymentDetails !== undefined &&
        (paymentDetails?.id == " " || paymentDetails.id == null)
      ) {
        return (
          <Button
            color="primary float-right"
            className="wizard-submit-btn"
            disabled
          >
            Submit
          </Button>
        );
      } else {
        if (orderId !== null) {
          return (
            <>
              {" "}
              {bookingupdateloader ? (
                <Button
                  color="primary float-right"
                  className="wizard-submit-btn"
                  disabled
                >
                  ...Updating
                </Button>
              ) : (
                <Button
                  color="primary float-right"
                  className="wizard-submit-btn"
                  onClick={UpdateBookigData}
                >
                  Submit
                </Button>
              )}
            </>
          );
        } else {
          return (
            <>
              {bookingloader ? (
                <Button
                  color="primary float-right"
                  className="wizard-submit-btn"
                  disabled
                >
                  ...Submiting
                </Button>
              ) : (
                <Button
                  color="primary float-right"
                  className="wizard-submit-btn"
                  onClick={AddBookingData}
                >
                  Submit
                </Button>
              )}
            </>
          );
        }
      }
    }
    return null;
  };

  const getTimeData = () => {
    const start_time = totalDuration;
    var hours = Math.floor(start_time / 60);
    var minutes = start_time % 60;
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var time = "0" + hours + ":" + minutes;
    return time;
  };

  function convertToHHMM(value) {
    const start_time = value;
    const hours = Math.floor(start_time / 60);
    const minutes = start_time % 60;

    // Format hours and minutes as two-digit numbers
    const formattedHours = hours < 10 ? "0" + hours : hours.toString();
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes.toString();

    // Combine hours and minutes in the "00:00" format
    const formattedTime = formattedHours + ":" + formattedMinutes;
    return formattedTime;
  }

  const checkAddonsQuantityChanged = (defaultAddons, chooseaddon) => {
    // Check if any default addon quantity has changed
    return defaultAddons.some(
      (addon, index) =>
        parseInt(addon.quantity) !== parseInt(chooseaddon[index]?.quantity)
    );
  };

  const isQuantityChanged = checkAddonsQuantityChanged(
    defaultaddons,
    chooseaddon
  );

  const recurringbookingdate = null;
  const recurringtime = null;

  const [bookingloader, setBookingLoader] = useState(false);

  const AddBookingData = () => {
    setBookingLoader(true);

    if (isBookingBlocked) {
      NotificationManager.error(
        "You cannot create a new booking while you have an attempted invoice. Please complete or resolve the invoice first.",
        "Error",
        4000
      );
      setBookingLoader(false);
      return;
    }

    if (choosedate === "") {
      alert("Please select date to add appointment");
      setBookingLoader(false);
      return;
    }

    // Check if this is a special client request (no slots available)
    const isSpecialRequest =
      specialClientRequests && specialClientRequests.trim() !== "";

    if (choosetime === "" && !isSpecialRequest) {
      alert("Please select time to add appointment");
      setBookingLoader(false);
      return;
    }

    if (choosetechnician === "" && !isSpecialRequest) {
      alert("Please select technician to add appointment");
      setBookingLoader(false);
      return;
    }

    const formData = new FormData();
    formData.append("user_id", LoggedInData.id);
    formData.append("type", usertype);
    formData.append("service_id", chooseservice);
    formData.append("book_by", 1);
    formData.append("request", specialClientRequests);

    // const staffIds = [];
    // for (let i = 0; i < choosetechnician.length; i++) {
    //   staffIds.push(choosetechnician[i].value);
    // }
    formData.append("sub_service_id", JSON.stringify(choosesubservice));

    // Check if special client request exists and no time slot was selected
    // choosetime could be "", [], or undefined when not selected
    const hasNoTimeSlot =
      !choosetime ||
      choosetime === "" ||
      (Array.isArray(choosetime) && choosetime.length === 0);

    // Debug logging
    console.log("=== Special Request Debug ===");
    console.log("specialClientRequests:", specialClientRequests);
    console.log("choosetime:", choosetime);
    console.log("hasNoTimeSlot:", hasNoTimeSlot);
    console.log("choosetechnician:", choosetechnician);

    if (
      specialClientRequests &&
      specialClientRequests.trim() !== "" &&
      hasNoTimeSlot
    ) {
      formData.append("staff_ids", "0");      //    formData.append("app_notes", specialClientRequests);
    } else {
      // Normal flow - use selected technician
      console.log("✅ Using normal flow - staff_ids =", choosetechnician);
      formData.append("staff_ids", choosetechnician);
      formData.append("app_notes", appointmentNotes);
    }
    // formData.append("amount", expectedprice);
    if (chooseservice === "1") {
      if (
        parseInt(choosesubservice[0]?.quantity) ===
          parseInt(defaultsubservice[0]?.quantity) &&
        parseInt(choosesubservice[1]?.quantity) ===
          parseInt(defaultsubservice[1]?.quantity) &&
        isQuantityChanged === false
      ) {
        if (!userbilledamount || userbilledamount == 0) {
          formData.append("amount", expectedprice);
        } else {
          formData.append("amount", userbilledamount);
        }
      } else {
        formData.append("amount", expectedprice);
      }
    } else {
      formData.append("amount", expectedprice);
    }
    formData.append(
      "client_name",
      LoggedInData.first_name + " " + LoggedInData.last_name
    );
    formData.append("firstname", LoggedInData.first_name);
    formData.append("lastname", LoggedInData.last_name);
    formData.append("client_email", LoggedInData.user_email);
    formData.append("client_phone", LoggedInData.phone);
    formData.append("client_address", LoggedInData.address);
    formData.append("client_city", LoggedInData.city);
    formData.append("client_state", LoggedInData.state);
    formData.append("client_zip", LoggedInData.zip);
    formData.append("client_zone", LoggedInData.zip);
    formData.append("coupon_id", promodata?.id);
    formData.append("coupon_code", promodata?.coupon_code);

    //discount price
    formData.append(
      "booking_discount",
      promodata?.type == 1
        ? (amountwithdiscount * promodata?.value) / 100
        : promodata?.value
    );

    // formData.append("billed_hours", convertToHHMM(expectedduration));
    // if (chooseservice === "1") {
    //   if (
    //     parseInt(choosesubservice[0]?.quantity) ===
    //       parseInt(defaultsubservice[0]?.quantity) &&
    //     parseInt(choosesubservice[1]?.quantity) ===
    //       parseInt(defaultsubservice[1]?.quantity) &&
    //     isQuantityChanged === false
    //   ) {
    //     if (!userbilledamount || userbilledamount == 0) {
    //       formData.append("billed_hours", convertToHHMM(expectedduration));
    //     } else {
    //       formData.append("billed_hours", convertToHHMM(userbilledhours));
    //     }
    //   } else {
    //     formData.append("billed_hours", convertToHHMM(expectedduration));
    //   }
    // } else {
    //   formData.append("billed_hours", convertToHHMM(expectedduration));
    // }

    // Set billed_hours based on shift: morning = 04:00, afternoon = 05:00
    const billedHours = selectedShift === "afternoon" ? "05:00" : "04:00";
    formData.append("billed_hours", billedHours);
    formData.append("bedrooms", LoggedInData.bedrooms);
    formData.append("bathrooms", LoggedInData.bathrooms);
    formData.append("user_pwd", LoggedInData.user_pwd);
    // formData.append("booking_discount", 0);
    formData.append("booking_notes", "");

    // For special client requests without time, use the selected date with shift-based default time
    // Morning shift: 08:00:00, Afternoon shift: 12:00:00
    // For normal flow without time, use shift-based default time
    const getDefaultTime = () => {
      if (selectedShift === "morning") {
        return "08:00:00";
      } else {
        return "12:00:00";
      }
    };

    const booking_date_time = choosetime
      ? moment(choosetime).format("YYYY-MM-DD HH:mm:ss")
      : hasNoTimeSlot &&
        specialClientRequests &&
        specialClientRequests.trim() !== ""
      ? moment(choosedate).format("YYYY-MM-DD") + " " + getDefaultTime()
      : moment(choosedate).format("YYYY-MM-DD") + " " + getDefaultTime();
    const order_date = choosetime
      ? moment(choosetime).format("YYYY-MM-DD")
      : moment(choosedate).format("YYYY-MM-DD");

    formData.append("booking_date_time", booking_date_time);
    formData.append("order_date", order_date);
    formData.append("payment_date", order_date);
    formData.append("recurring_booking_date", recurringbookingdate);
    formData.append("recurring_time_to", recurringtime);
    formData.append("addons", JSON.stringify(chooseaddon));

    if (chooseservice === "1") {
      if (
        parseInt(choosesubservice[0]?.quantity) ===
          parseInt(defaultsubservice[0]?.quantity) &&
        parseInt(choosesubservice[1]?.quantity) ===
          parseInt(defaultsubservice[1]?.quantity) &&
        isQuantityChanged === false
      ) {
        if (!userbilledamount || userbilledamount == 0) {
          formData.append(
            "estimated_price",
            "$" + Totalpayment + " to $" + Math.round(expectedprice)
          );
          formData.append(
            "estimated_duration",
            convertToHHMM(totalDuration) +
              " to " +
              convertToHHMM(expectedduration)
          );
        } else {
          formData.append(
            "estimated_price",
            "$" + userbilledamount + " to $" + Math.round(userbilledamount)
          );
          formData.append(
            "estimated_duration",
            convertToHHMM(userbilledhours) +
              " to " +
              convertToHHMM(userbilledhours)
          );
        }
      } else {
        // formData.append("estimated_duration", "$" + (Totalpayment) + " to $" + Math.round((expectedprice)));
        // formData.append("estimated_price", convertToHHMM(totalDuration) + " to " + convertToHHMM(expectedduration));
        formData.append(
          "estimated_price",
          "$" + Totalpayment + " to $" + Math.round(expectedprice)
        );
        formData.append(
          "estimated_duration",
          convertToHHMM(totalDuration) +
            " to " +
            convertToHHMM(expectedduration)
        );
      }
    } else {
      formData.append(
        "estimated_price",
        "$" + Totalpayment + " to $" + Math.round(expectedprice)
      );
      formData.append(
        "estimated_duration",
        convertToHHMM(totalDuration) + " to " + convertToHHMM(expectedduration)
      );
    }

    if (
      recurringbookingdate !== "" &&
      recurringtime !== "" &&
      recurringbookingdate !== null &&
      recurringtime !== null
    ) {
      formData.append("recurring_status", "Y");
    } else {
      formData.append("recurring_status", "N");
    }

    if (paymentDetails != null) {
      formData.append("paymentDetails", JSON.stringify(paymentDetails));
      formData.append("customer_id", LoggedInData.customer_id);
    }

    addbooking(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status === "1") {
          setBookingLoader(false);
          NotificationManager.info("Booking Added Successfully");
          // setUsertype('');
          setChoosetechnician("");
          setChoosedate("");
          setChoosetime("");
          window.location.href = "/userdashboard";
        } else {
          alert("Booking Not Added");
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const [bookingupdateloader, setBookingUpdateLoader] = useState(false);

  const UpdateBookigData = () => {
    setBookingUpdateLoader(true);
    const formData = new FormData();
    formData.append("order_id", orderId);
    formData.append("client_id", LoggedInData.id);
    formData.append("service_id", chooseservice);
    formData.append("start_date", moment(choosetime).format("YYYY-MM-DD"));
    formData.append("start_d_time", moment(choosetime).format("HH:mm"));
    if (chooseservice === "1") {
      if (
        parseInt(choosesubservice[0]?.quantity) ===
          parseInt(defaultsubservice[0]?.quantity) &&
        parseInt(choosesubservice[1]?.quantity) ===
          parseInt(defaultsubservice[1]?.quantity) &&
        isQuantityChanged === false
      ) {
        if (!userbilledamount || userbilledamount == 0) {
          formData.append("service_amount", expectedprice);
        } else {
          formData.append("service_amount", userbilledamount);
        }
      } else {
        formData.append("service_amount", expectedprice);
      }
    } else {
      formData.append("service_amount", expectedprice);
    }
    if (chooseservice === "1") {
      if (
        parseInt(choosesubservice[0]?.quantity) ===
          parseInt(defaultsubservice[0]?.quantity) &&
        parseInt(choosesubservice[1]?.quantity) ===
          parseInt(defaultsubservice[1]?.quantity) &&
        isQuantityChanged === false
      ) {
        if (!userbilledamount || userbilledamount == 0) {
          formData.append("duration", expectedduration);
        } else {
          formData.append("duration", userbilledhours);
        }
      } else {
        formData.append("duration", expectedduration);
      }
    } else {
      formData.append("duration", expectedduration);
    }
    formData.append("appointment_note_by_staff", appointmentNotes);
    formData.append("appointment_zip", LoggedInData.zip);
    formData.append("appointment_address", LoggedInData.address);
    formData.append("appointment_city", LoggedInData.city);
    formData.append("appointment_state", LoggedInData.state);
    formData.append("client_name", LoggedInData.first_name);

    formData.append("booking_discount", 0);

    if (chooseservice === "1") {
      if (
        parseInt(choosesubservice[0]?.quantity) ===
          parseInt(defaultsubservice[0]?.quantity) &&
        parseInt(choosesubservice[1]?.quantity) ===
          parseInt(defaultsubservice[1]?.quantity) &&
        isQuantityChanged === false
      ) {
        if (!userbilledamount || userbilledamount == 0) {
          formData.append(
            "estimated_price",
            "$" + Totalpayment + " to $" + Math.round(expectedprice)
          );
          formData.append(
            "estimated_duration",
            convertToHHMM(totalDuration) +
              " to " +
              convertToHHMM(expectedduration)
          );
        } else {
          formData.append(
            "estimated_price",
            "$" + userbilledamount + " to $" + Math.round(userbilledamount)
          );
          formData.append(
            "estimated_duration",
            convertToHHMM(userbilledhours) +
              " to " +
              convertToHHMM(userbilledhours)
          );
        }
      } else {
        // formData.append("estimated_duration", "$" + (Totalpayment) + " to $" + Math.round((expectedprice)));
        // formData.append("estimated_price", convertToHHMM(totalDuration) + " to " + convertToHHMM(expectedduration));
        formData.append(
          "estimated_price",
          "$" + Totalpayment + " to $" + Math.round(expectedprice)
        );
        formData.append(
          "estimated_duration",
          convertToHHMM(totalDuration) +
            " to " +
            convertToHHMM(expectedduration)
        );
      }
    } else {
      formData.append(
        "estimated_price",
        "$" + Totalpayment + " to $" + Math.round(expectedprice)
      );
      formData.append(
        "estimated_duration",
        convertToHHMM(totalDuration) + " to " + convertToHHMM(expectedduration)
      );
    }

    const subServices = [];
    for (let i = 0; i < choosesubservice.length; i++) {
      // subServices.push(EditSubServices[i].quantity);
      subServices.push({
        id: choosesubservice[i].booking_id,
        quantity: choosesubservice[i].quantity,
      });
    }
    formData.append("method_unit_selected_values", JSON.stringify(subServices));

    const addons = [];
    for (let i = 0; i < chooseaddon.length; i++) {
      addons.push({
        id: chooseaddon[i].id,
        quantity: chooseaddon[i].quantity,
        type: chooseaddon[i].new,
      });
    }
    formData.append("addons_service_qty", JSON.stringify(addons));

    formData.append("staff_ids", choosetechnician);

    updateBookingData(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            setBookingUpdateLoader(false);
            // alert("Booking updated successfully");
            window.location.href = "/userdashboard";
          } else {
            alert("Something went wrong");
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  return (
    <>
      {/* <Form> */}
      <div className="card booking-form-card">
        <div className="card-body">
          {!invoiceCheckDone ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "400px",
                padding: "40px 20px",
                textAlign: "center",
              }}
            >
              <div
                className="spinner-border"
                role="status"
                style={{
                  width: "3rem",
                  height: "3rem",
                  color: "#75B317",
                  borderWidth: "0.3em",
                }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <p
                style={{
                  marginTop: "20px",
                  color: "#3F4B5E",
                  fontSize: "16px",
                }}
              >
                Checking your invoice status...
              </p>
            </div>
          ) : isBookingBlocked ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "400px",
                padding: "40px 20px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "#EAF4DC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                  border: "3px solid #75B317",
                }}
              >
                <FaExclamationTriangle
                  style={{
                    fontSize: "40px",
                    color: "#75B317",
                  }}
                />
              </div>
              <h3
                style={{
                  color: "#75B317",
                  fontWeight: "600",
                  marginBottom: "15px",
                  fontSize: "24px",
                }}
              >
                Pay Now
              </h3>
              {/* <div className="booking-card-header-title">
                {invoiceAttemptedMessage ? "You have ATTEMPTED invoice" :
                  "Your invoice is attempted. You cannot create a new booking right now. Please resolve your invoice first."}
              </div> */}
              <div
                style={{
                  padding: "15px 30px",
                  backgroundColor: "#fbfbfb",
                  borderRadius: "8px",
                  border: "1px solid #EDEDED",
                  maxWidth: "400px",
                }}
              >
                <p
                  style={{
                    color: "#3F4B5E",
                    fontSize: "16px",
                    fontWeight: "500",
                    margin: "0",
                    fontStyle: "italic",
                  }}
                >
                  Please settle your outstanding balance to continue booking.
                </p>
              </div>
            </div>
          ) : (
            <>
              <div className="card-title">
                <MultiStepProgressBar currentStep={currentStep} />
              </div>
              <Step1
                currentStep={currentStep}
                handleChange={handleChange}
                email={email}
                availableTimestatus={false}
                order_Id={orderId}
              />
              <Step2
                currentStep={currentStep}
                handleChange={handleChange}
                email={username}
                order_Id={orderId}
                validationError={validationError}
                clearValidationError={() => setValidationError("")}
                setSlotsAvailable={(hasSlots) => {
                  // Store slots availability for validation
                  window.slotsAvailable = hasSlots;
                }}
              />
              <Step3
                currentStep={currentStep}
                handleChange={handleChange}
                email={password}
                order_Id={orderId}
              />
              <Step4
                currentStep={currentStep}
                handleChange={handleChange}
                email={address}
                order_Id={orderId}
              />
            </>
          )}
        </div>
        {invoiceCheckDone && !isBookingBlocked && (
          <div className="card-footer booking-card-btn-footer">
            {previousButton()}
            {nextButton()}
            {submitButton()}
          </div>
        )}
      </div>
      <NotificationContainer />
      {/* </Form> */}
    </>
  );
};

export default MasterForm;
